import {
  SET_POIASSETS_CONFIG,
  SET_GEOENTITIES_AT_ADDRESS_CONFIG,
  SET_POIS_ON_ROUTE_CONFIG,
  SET_POIASSETS_STATUS
} from './poiassets.actionTypes'
import {
  extractMenus,
  extractApps,
  extractCategories,
  extractSubcategories,
  parseGeoentitiesConfig,
  extractFreeApps
} from './poiassets.dataParsers'
import {
  requestPoiassetsConfig,
  requestGeoentitiesAtAddressConfig,
  requestPoisOnRouteConfig
} from '../../dataSource/poiassets/poiassets.requests'
import { selectPoiAssetsStatus } from './poiassets.selectors'
import { POIASSETS_STATUS } from './poiassets.constants'

export const loadPoiAssetsConfiguration = () => (dispatch, getState) => {
  const status = selectPoiAssetsStatus(getState())

  if (status === POIASSETS_STATUS.REQUESTING || status === POIASSETS_STATUS.DONE) return Promise.resolve()

  dispatch({ type: SET_POIASSETS_STATUS, payload: { status: POIASSETS_STATUS.REQUESTING } })

  return requestPoiassetsConfig().then(response => {
    if (!response.data) {
      dispatch({ type: SET_POIASSETS_STATUS, payload: { status: POIASSETS_STATUS.INITIAL } })
      return Promise.resolve()
    }

    dispatch({
      type: SET_POIASSETS_CONFIG,
      payload: {
        menus: extractMenus(response.data),
        apps: extractApps(response.data),
        freeapps: extractFreeApps(response.data),
        categories: extractCategories(response.data),
        subcategories: extractSubcategories(response.data)
      }
    })
  })
}

const loadGeoentitiesAtAddressConfiguration = () => (dispatch, getState) => {
  if (getState().poiassets.geoentitiesAtAddressConfig) return

  return requestGeoentitiesAtAddressConfig().then(response => {
    if (!response.data) return

    dispatch({
      type: SET_GEOENTITIES_AT_ADDRESS_CONFIG,
      payload: parseGeoentitiesConfig(response.data)
    })
  })
}

const loadPoisOnRouteConfiguration = () => (dispatch, getState) => {
  if (getState().poiassets.poisOnRouteConfig) return

  return requestPoisOnRouteConfig().then(response => {
    if (!response.data) return

    dispatch({
      type: SET_POIS_ON_ROUTE_CONFIG,
      payload: parseGeoentitiesConfig(response.data)
    })
  })
}

export const loadCompleteGeoentitiesAtAddressConfiguration = () => (dispatch, getState) =>
  Promise.all([
    loadPoiAssetsConfiguration()(dispatch, getState),
    loadGeoentitiesAtAddressConfiguration()(dispatch, getState)
  ])

export const loadCompletePoisOnRouteConfiguration = () => (dispatch, getState) =>
  Promise.all([loadPoiAssetsConfiguration()(dispatch, getState), loadPoisOnRouteConfiguration()(dispatch, getState)])
